import { FC, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import PCCom from '../../components/PCCom';
import H5Com from '../../components/H5Com';
import NestingSwiper from '../../components/NestingSwiper';
import { useDP3Store } from '../../DP3Provider';
import { IPageStatus } from '../../components/IPageStatus';
import styles from './index.module.scss';
import ComJP from './ComJP';
import { useLang } from '@/i18n';

const TheComp: FC = () => {
    const { locale } = useRouter();
    const IS_EU_SITES = ['eu', 'de', 'fr', 'it', 'es'].includes(locale);
    const { pageStatus } = useDP3Store();
    const { t } = useLang(IS_EU_SITES ? 'dp3.landing.Smoothly' : 'dp3.teaser.Smoothly');
    const { t: t2 } = useLang('dp3.landing.SmoothlyJp');
    const [isPC, setIsPC] = useState(true);
    const isCROWDFUNDING = pageStatus === IPageStatus.statusB;

    useEffect(() => {
        setIsPC(window.innerWidth > 1024);
    }, []);

    return (
        <div id="dp3-teaser-E" className={`dp3-module-box Smoothly dp3-teaser-E ${styles.theComp}`}>
            {isPC ? (
                locale === 'jp' ? (
                    <ComJP
                        title={t('title')}
                        imgArr={[
                            'https://websiteoss.ecoflow.com/upload/image/1736742894310/20250113-123032.jpeg',
                            'https://ecoflow-service-us-cdn.ecoflow.com/upload/video/1717753570042/-abf6-42e0-a77c-753f9097aa5d.mp4',
                        ]}
                        imgArrInfo={[
                            {
                                upTitle: isCROWDFUNDING ? t2('item1_up_title') : null,
                                title: t('lMsg'),
                                desc: t.rich('rMsg', {
                                    code1: (text: string) => <sup className="comp-color-2">{text}</sup>,
                                }),
                                rMsTips: isCROWDFUNDING ? t2('item1_r_tips') : null,
                            },
                            {
                                upTitle: isCROWDFUNDING ? t2('item2_up_title') : null,
                                title: t.rich('lMsg2', {
                                    code1: (text: string) => <sup className="comp-color-2">{text}</sup>,
                                }),
                                desc: t.rich('rMsg2', {
                                    code1: (text: string) => <sup className="comp-color-2">{text}</sup>,
                                }),
                                lMsTips: isCROWDFUNDING ? t('lMsgTips') : null,
                                lMsTipsLink: isCROWDFUNDING ? '#ConsultingService1' : null,
                                rMsTips: isCROWDFUNDING ? t2('item2_r_tips') : null,
                                rMsTips2: isCROWDFUNDING ? t('rMsg2Tips2') : null,
                            },
                        ]}
                        cls="dp3-teaser-E"
                    />
                ) : (
                    <PCCom
                        title={t('title')}
                        img={
                            locale === 'cn'
                                ? 'https://websiteoss.ecoflow.com/upload/image/1737773169090/2.jpg'
                                : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717657374538/Frame%201000008360%20(1)%20(1).png'
                        }
                        subtitle={t('lMsg')}
                        desc={t('rMsg')}
                        tips={t('tips')}
                    />
                )
            ) : locale === 'jp' ? (
                <NestingSwiper
                    title={t('title')}
                    data={[
                        {
                            title: t('lMsg'),
                            desc: t.rich('rMsg', {
                                code1: (text: string) => <sup className="comp-color-2">{text}</sup>,
                            }),
                            imgs: [
                                { img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717756103653/bb4.jpg' },
                                {
                                    img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717755208295/tt1.jpg',
                                },
                            ],
                        },
                        {
                            title: t.rich('lMsg2', {
                                code1: (text: string) => <sup className="comp-color-2">{text}</sup>,
                            }),
                            desc: t.rich('rMsg2', {
                                code1: (text: string) => <sup className="comp-color-2">{text}</sup>,
                            }),
                            lMsTips: isCROWDFUNDING ? t('lMsgTips') : null,
                            lMsTipsLink: isCROWDFUNDING ? '#ConsultingService1' : null,
                            rMsTips: isCROWDFUNDING ? t2('item2_r_tips') : null,
                            rMsTips2: isCROWDFUNDING ? t('rMsg2Tips2') : null,
                            imgs: [{ img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/video/1717753694762/-ec17-4c38-8ae6-8d649855ec68.mp4' }],
                        },
                    ]}
                    // imgArr={[
                    //     'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717752580812/Frame%201000007972%20(1).jpg',
                    //     'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717752609441/Frame%201000008286.jpg',
                    // ]}
                    // imgArrInfo={[
                    //     {
                    //         title: t('lMsg'),
                    //         desc: t.rich('rMsg', {
                    //             code1: (text: string) => <sup className="comp-color-2">{text}</sup>,
                    //         }),
                    //     },
                    //     {
                    //         title: t.rich('lMsg2', {
                    //             code1: (text: string) => <sup className="comp-color-2">{text}</sup>,
                    //         }),
                    //         desc: t.rich('rMsg2', {
                    //             code1: (text: string) => <sup className="comp-color-2">{text}</sup>,
                    //         }),
                    //     },
                    // ]}
                    // cls="dp3-teaser-E"
                />
            ) : (
                <H5Com
                    title={t('title')}
                    imgArr={
                        locale === 'cn'
                            ? [
                                  'https://websiteoss.ecoflow.com/upload/image/1737773168907/2_1_M.jpg',
                                  'https://websiteoss.ecoflow.com/upload/image/1739178895958/2_2_M.jpg',
                              ]
                            : [
                                  'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717759955595/tt1%202.jpg',
                                  'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717760035759/tt2.jpg',
                              ]
                    }
                    subtitle={t('lMsg')}
                    desc={t('rMsg')}
                    tips={t('tips')}
                    cls="dp3-teaser-E"
                />
            )}
        </div>
    );
};

export default TheComp;
